export const RECORDKEEPER_RULES = [
  {
    target: 'American Funds PlanPremier',
    containsAny: [
      'American Funds Premier',
      'American Funds Plan',
      'American Funds Plan Premier',
      'PlanPremier',
      'Plan Premier',
    ],
  },
  {
    target: 'American Funds RecordkeeperDirect',
    containsAny: [
      'American Funds Direct',
      'American Funds Recordkeeper Direct',
      'American Funds Recordkeeper',
      'RecordkeeperDirect',
      'Recordkeeper Direct',
    ],
  },
  {
    target: 'Ascensus',
    containsAny: ['ascensus'],
  },
  {
    target: 'Empower',
    containsAny: ['empower'],
  },
  {
    target: 'John Hancock',
    containsAny: ['john hancock'],
  },
  {
    target: 'Transamerica',
    containsAny: ['transamerica', 'trans america'],
  },
  {
    target: 'T. Rowe Price',
    containsAny: ['t rowe price', 'rowe price'],
  },
  {
    target: 'Fidelity',
    containsAny: ['fidelity'],
  },
  {
    target: 'TIAA',
    containsAny: ['tiaa'],
  },
  {
    target: 'The Standard',
    containsAny: ['the standard', 'standard', 'thestandard'],
  },
  {
    target: 'Corebridge Financial',
    containsAny: [
      'corebridge financial',
      'CorebridgeFinancial',
      'AIG',
      'corebridge',
    ],
  },
  {
    target: 'Paychex',
    containsAny: ['paychex'],
  },
  {
    target: 'Vanguard',
    containsAny: ['vanguard'],
  },
  {
    target: 'Ameritas',
    containsAny: ['ameritas'],
  },
  {
    target: 'Equitable',
    containsAny: ['equitable'],
  },
  {
    target: 'Charles Schwab',
    containsAny: ['charles schwab'],
  },
  {
    target: 'Betterment for Business, LLC',
    containsAny: ['betterment', 'betterment for business'],
  },
  {
    target: 'Vestwell',
    containsAny: ['vestwell'],
  },
  {
    target: 'Principal',
    containsAny: ['principal'],
  },
  {
    target: 'GuideStone',
    containsAny: ['guidestone', 'guide stone'],
  },
  {
    target: 'Voya',
    containsAny: ['voya'],
  },
  {
    target: 'Conduent',
    containsAny: ['conduent'],
  },
  {
    target: 'Nationwide',
    containsAny: ['nationwide'],
  },
]
